import styled from "styled-components";

export const AppContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
`;